import { getSutochnoPilot } from '../../services/getSutochnoPilot';
import { TThunkAction } from '../../types/redux';
import { loadSutochnoPilotStart } from './loadSutochnoPilotStart';
import { loadSutochnoPilotSuccess } from './loadSutochnoPilotSuccess';

interface ILoadSutochnoPilotParams {
  userAgent: string;
}

export function loadSutochnoPilot(params: ILoadSutochnoPilotParams): TThunkAction<Promise<void>> {
  return async (dispatch, _, context) => {
    const { userAgent } = params;
    const { httpApi, logger, config, telemetry } = context;

    const timeout = config.get<number>('billingAccounts.timeout') || undefined;

    dispatch(loadSutochnoPilotStart());

    const response = await getSutochnoPilot({ httpApi, logger, telemetry, timeout, userAgent });

    dispatch(loadSutochnoPilotSuccess(response));
  };
}
